import { Component, OnInit } from '@angular/core';
import { Customer } from '../customer.model';
import { OptionService } from '../option.service';
import { LocalStorageService } from 'ngx-webstorage';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-perm-notifications',
  templateUrl: './perm-notifications.component.html',
  styleUrls: ['./perm-notifications.component.css']
})
export class PermNotificationsComponent implements OnInit {

  customers: Customer[] = [];
  userLoginId!: string;
  title!: string;
  body!: string;
  selectAll: boolean = true;
  form!: FormGroup;
  spinnerOverlay = false;
  selectedCustomers: string[] = [];
  _selectedCustomers: string[] = [];
  

  constructor(private optionService: OptionService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private localStorage: LocalStorageService) {
  }

  ngOnInit(): void {
    this.getCustomers();
  }

  getCustomers() {
    this.userLoginId = this.localStorage.retrieve("userInfo").userId;
    this.optionService.getAllCustomers(this.userLoginId).subscribe(data => {

      for (let i = 0; i < data.length; i++) {
        let customer = {} as Customer;
        customer.id = data[i]['id'];
        customer.fullName = data[i]['fullName'];
        customer.userName = data[i]['userName'];
        customer.email = data[i]['email'];
        customer.balance = data[i]['balance'];
        customer.dept = data[i]['dept'];
        customer.approved = data[i]['approved'];
        customer.userCategoryId = data[i]['userCategoryId'];
        customer.newBallance = data[i]['newBallance'];
        customer.fcmRegToken = data[i]['fcmRegToken'];
        this.customers.push(customer);
      }

    }, error => {
      console.log(error);
    })
  }

  fillDataPost(): any {
    var obj =
    {
      "title": this.title,
      "message": this.body,
      "usersIds": this._selectedCustomers,
      "createBy":this.userLoginId
    }
    return obj;
  }

  sendNotification() {

    this._selectedCustomers = [];
    if (this.selectAll) {
   this._selectedCustomers = this.customers.map(({ id }) => id);
    }
    else{
      this._selectedCustomers = this.selectedCustomers;
    }

    this.spinnerOverlay = true;
    var obj = this.fillDataPost();

    this.optionService.createPermNotifications(obj).subscribe(data => {

      this.openSnackBar(this.translateService.instant("sendSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error)
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }
        this.spinnerOverlay = false;
      });

  }

  fillDataFirebase(fcmToken: string): any {
    var obj = {
      "to": fcmToken,
      "data": {
        "title": this.title,
        "message": this.body
      }
    }

    return obj;
  }

  submit() {
    this.sendNotification();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

}
